// Testi di guida mostrati in cima a ogni pagina: spiegano cosa si vede e cosa si può fare.
export const GUIDE = {
  "/dashboard": {
    titolo: "A cosa serve questa pagina",
    testo:
      "È il quadro d'insieme del progetto: quanto è stato fatto, cosa è in corso e dove ci sono problemi. I numeri si aggiornano da soli ogni volta che qualcuno dichiara un avanzamento.",
    vedi: [
      "Le percentuali di avanzamento: quella dichiarata da chi sviluppa e quella consolidata che vede il cliente finale",
      "Il grafico a torta con la situazione dei task: da iniziare, in corso, in test, approvati, respinti",
      "Quante volte un lavoro è stato rifatto (rework) e quale tester lo ha respinto",
      "Lo storico giorno per giorno, per capire se il progetto sta accelerando o rallentando",
    ],
    fai: [
      "Cambia sprint dal menu in alto per vedere solo quel periodo",
      "Scarica il piano aggiornato in Excel",
      "Chiedi al robot PM-Bot in basso a destra come sta andando: te lo racconta a voce",
    ],
  },
  "/area-dev": {
    titolo: "A cosa serve questa pagina",
    testo:
      "È l'area del Dev: puoi lavorare su tutte le attività del progetto e consolidare le percentuali dichiarate dal fornitore. La percentuale che confermi qui è quella che vede il cliente finale.",
    vedi: [
      "Tutte le attività del progetto, con chi le esegue, date previste e giorni stimati",
      "La percentuale dichiarata dal fornitore accanto a quella consolidata da te",
      "Quante volte un'attività è stata respinta dal tester",
    ],
    fai: [
      "Consolida con 'Allinea al fornitore' per accettare il valore dichiarato, oppure imposta la percentuale a mano",
      "Porta l'attività a 'In Test' quando è pronta: dopo l'esito spetta al tester e non potrai più modificarla",
      "Se è arrivato un KO, apri 'KO dal tester' per leggere il bug, scaricare l'allegato e riprenderla in lavorazione",
      "Importa un piano Excel per aggiornare in blocco le attività",
    ],
  },
  "/area-pm": {
    titolo: "A cosa serve questa pagina",
    testo:
      "È la vista del PM: il piano completo del progetto in sola lettura. Puoi controllare tutto senza rischiare di modificare nulla per sbaglio.",
    vedi: [
      "Tutte le attività con percentuali, stato, rework e note di chi lavora",
      "La cronologia delle modifiche di ogni attività",
    ],
    fai: [
      "Usa i filtri per sprint, persona, stato o testo per trovare quello che cerchi",
      "Per i dati di qualità e i respingimenti vai su 'Qualità & Test'",
    ],
  },
  "/piano-interno": {
    titolo: "A cosa serve questa pagina",
    testo:
      "È l'elenco completo delle attività del progetto, con lo stato e l'avanzamento di ognuna. Da qui si aggiorna il lavoro svolto.",
    vedi: [
      "Un riquadro per ogni attività, con il codice, chi la esegue, le date previste e i giorni stimati",
      "Due percentuali: quella dichiarata da Stefano Critelli e quella consolidata da Majorbit",
      "Lo stato dell'attività e quante volte è stata rifatta",
    ],
    fai: [
      "Trascina le barre per aggiornare le percentuali: il salvataggio è automatico",
      "Cambia lo stato fino a 'In Test': da quel momento l'esito spetta al tester",
      "Apri 'Cronologia modifiche' su un'attività per vedere chi ha cambiato cosa e quando",
      "Usa i filtri in alto per trovare subito un'attività per sprint, persona, stato o testo",
    ],
  },
  "/area-fornitore": {
    titolo: "A cosa serve questa pagina",
    testo:
      "Qui vedi solo le attività in carico a Stefano Critelli e dichiari quanto hai fatto. Majorbit userà la tua dichiarazione per consolidare l'avanzamento ufficiale.",
    vedi: [
      "Solo le tue attività, con date previste, giorni stimati e note",
      "La tua percentuale dichiarata e, in sola lettura, quella consolidata da Majorbit",
    ],
    fai: [
      "Aggiorna la tua percentuale e scrivi le note sul lavoro svolto",
      "Porta l'attività a 'In Test' quando è pronta per la verifica: dopo non è più modificabile",
      "Se il tester l'ha respinta, apri 'KO dal tester' per leggere il bug, scaricare l'allegato e riprenderla in lavorazione",
    ],
  },
  "/area-test": {
    titolo: "A cosa serve questa pagina",
    testo:
      "È l'area del tester: compaiono solo le attività consegnate alla verifica. Qui si decide se un lavoro è accettato o va rifatto.",
    vedi: [
      "Solo le attività in stato 'In Test', cioè quelle che gli sviluppatori hanno dichiarato pronte",
      "Lo storico degli esiti già dati, con le note e chi ha testato",
      "Le test list di fine sprint già caricate (visibili solo a Tester e PM)",
    ],
    fai: [
      "Scrivi cosa hai verificato nelle note di test",
      "Premi OK per approvare: l'attività va al 100% ed è chiusa",
      "Premi KO per respingere: servono obbligatoriamente le note del bug e un allegato (screenshot, log o report). L'attività torna in lavorazione",
      "A fine sprint allega la test list: resta scaricabile solo da Tester e PM",
    ],
  },
  "/milestone-cliente": {
    titolo: "A cosa serve questa pagina",
    testo:
      "Sono i traguardi concordati con il cliente finale. Le percentuali si calcolano da sole dalle attività consolidate: nessuno le scrive a mano.",
    vedi: [
      "Ogni milestone con la data obiettivo, la percentuale raggiunta e il risultato atteso",
      "Un semaforo che dice se è in orario, a rischio o in ritardo",
      "Chi ha approvato la milestone, quando e con quale commento",
    ],
    fai: [
      "Se sei Infocamere, scrivi un commento e approva la milestone: resta registrato con data e ora",
      "Puoi anche revocare un'approvazione già data",
    ],
  },
  "/sprint-review": {
    titolo: "A cosa serve questa pagina",
    testo:
      "È il resoconto di fine sprint da condividere: i numeri del periodo, i problemi e le note di chiusura, pronti da inviare o scaricare in PDF.",
    vedi: [
      "I numeri dello sprint: avanzamento, attività chiuse, rework e giorni consumati",
      "Il consuntivo 'Stima contro effettivo': quanti giorni erano stati stimati e quanti sono stati realmente erosi, con l'elenco delle attività uscite dalla stima",
      "Il dettaglio attività per attività e lo stato delle milestone",
      "Lo storico degli invii, con l'indicazione di quelli partiti automaticamente",
    ],
    fai: [
      "Apri 'Dettaglio completo' per vedere attività per attività i giorni stimati, quelli erosi e lo scostamento",
      "Scrivi le note di review: finiscono nel PDF e nell'email",
      "Genera il PDF della review, firmato in fondo",
      "Invia la review via email adesso, oppure lascia che parta da sola alla data di chiusura dello sprint",
    ],
  },
  "/documenti": {
    titolo: "A cosa serve questa pagina",
    testo:
      "È l'archivio del progetto: analisi funzionale, analisi tecnica, piani e verbali. Ognuno vede solo i documenti abilitati per il proprio profilo.",
    vedi: [
      "I documenti caricati, con categoria, peso, data e chi li ha caricati",
      "Per chi è visibile ogni documento",
      "I piani del progetto generati al momento in Excel, sempre aggiornati",
    ],
    fai: [
      "Scarica un documento o un piano Excel",
      "Se sei admin, carica un nuovo documento scegliendo chi può vederlo",
    ],
  },
  "/storico": {
    titolo: "A cosa serve questa pagina",
    testo:
      "È il registro di tutto ciò che è stato cambiato: utile per capire chi ha dichiarato cosa e quando, senza discussioni.",
    vedi: [
      "Ogni modifica con utente, data e ora, valore precedente e valore nuovo",
      "Le azioni importanti: consolidamenti, esiti di test, approvazioni, import e invii",
      "Per l'admin, anche chi ha aperto o scaricato i documenti riservati, con indirizzo IP",
    ],
    fai: [
      "Filtra per persona, codice dell'attività, tipo di dato o periodo",
      "Scrivi anche solo una parte del codice (per esempio NF00) per trovare tutte le attività collegate",
    ],
  },
  "/qualita": {
    titolo: "A cosa serve questa pagina",
    testo:
      "Racconta come sta andando la qualità del lavoro: quante verifiche sono state fatte, quante respinte e su quali attività i problemi tornano.",
    vedi: [
      "Quante verifiche sono state eseguite, quante approvate e quante respinte",
      "La classifica per tester, con la percentuale di lavori respinti",
      "Le attività respinte più volte: sono i punti dove il progetto perde tempo",
      "Le attività in attesa di verifica e quelle rientrate in lavorazione",
    ],
    fai: [
      "Filtra per sprint per confrontare i periodi",
      "Parti dalle attività con più respingimenti per capire dove intervenire",
    ],
  },
  "/organizzazioni": {
    titolo: "A cosa serve questa pagina",
    testo:
      "Qui si configura la catena del progetto: chi è il fornitore, chi è il cliente e chi è il cliente finale. È il primo passo prima di creare i profili.",
    vedi: ["Le organizzazioni già configurate, con il tipo, il referente e una nota descrittiva"],
    fai: [
      "Aggiungi un'organizzazione indicando se è fornitore, cliente o cliente finale",
      "Eliminala se non serve più: non è possibile se ci sono ancora profili collegati",
    ],
  },
  "/progetti": {
    titolo: "A cosa serve questa pagina",
    testo:
      "Da qui si creano e si gestiscono i progetti. Ogni nuovo progetto nasce già pronto con sprint, milestone e attività da personalizzare.",
    vedi: ["L'elenco dei progetti con cliente, date e quante attività contengono"],
    fai: [
      "Crea un nuovo progetto partendo dal modello già impostato",
      "Rigenera un progetto dal modello per riportarlo alla situazione iniziale",
      "Elimina un progetto: vengono cancellati anche i suoi dati collegati",
    ],
  },
  "/utenti": {
    titolo: "A cosa serve questa pagina",
    testo:
      "Qui si creano i profili di accesso e si decide cosa ciascuno può fare. Il ruolo scelto determina i permessi in tutta l'applicazione.",
    vedi: ["Tutti i profili con il ruolo assegnato, l'organizzazione e la persona di riferimento"],
    fai: [
      "Crea un profilo: scegli il ruolo e leggi la descrizione che compare sotto per capire cosa potrà fare",
      "Elimina un profilo che non deve più accedere",
    ],
  },
};

// Spiegazioni brevi mostrate nei tooltip accanto ai campi.
export const AIUTI = {
  percFornitore:
    "Percentuale dichiarata da chi sviluppa l'attività: trascina lo slider per indicare un avanzamento parziale. Quando porti il task 'In Test' va automaticamente al 100%.",
  percCliente:
    "Percentuale consolidata da Majorbit: è l'unica che vede il cliente finale e l'unica che alimenta le milestone. Puoi indicare avanzamenti parziali; alla consegna in test va automaticamente al 100% e con un KO torna a 0%.",
  stato:
    "Da iniziare, In Progress, In Test, OK, KO. Chi sviluppa può arrivare fino a 'In Test': OK e KO li decide il tester.",
  rework: "Quante volte l'attività è stata respinta dal tester e rifatta.",
  noteEsecutore: "Note di chi sta lavorando l'attività: cosa è stato fatto, cosa manca.",
  noteCliente: "Note di governance di Majorbit, visibili nei piani esportati.",
  assegnatario: "Persona responsabile dell'attività.",
  allinea: "Copia nella percentuale consolidata il valore dichiarato dal fornitore, accettandolo così com'è.",
  esecutore: "Chi esegue l'attività: il fornitore Stefano Critelli oppure il cliente Majorbit.",
  noteTest: "Descrivi cosa hai verificato. In caso di KO è obbligatorio e serve allo sviluppatore per correggere.",
  allegatoKo:
    "Obbligatorio per il KO: allega uno screenshot, un log o un report che dimostri il problema. Lo sviluppatore potrà scaricarlo.",
  testlist:
    "Il documento che chiude lo sprint con l'elenco dei test eseguiti e il loro esito. Scaricabile solo da Tester e PM.",
  importExcel:
    "Carica un piano Excel: le attività esistenti vengono aggiornate in base al codice e quelle nuove vengono aggiunte.",
  visibilita: "Scegli quali profili potranno vedere e scaricare il documento.",
  sprintSequenza:
    "Gli sprint avanzano in ordine: per lavorare sul successivo, tutte le attività del precedente devono essere almeno 'In Test'.",
};
